import type { AddTaskTemplateFormValues } from "@/components/Forms/SubForms/AddEditTaskTempalteDialog.tsx";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useAddTaskTemplate = (
    taskTemplateUUID?: string,
): UseMutationResult<AddTaskTemplateFormValues, Error, AddTaskTemplateFormValues> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (attributes) => {
            const body = {
                taskTemplateUUID: taskTemplateUUID,
                ...attributes,
            };

            const response = await fetch(apiUrl("/task-template/add-edit"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify(body),
            });
            await handleJsonApiError(response);
            return await response.json();
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["task-templates"],
            });
        },
    });
};
